import { useRef, useEffect } from 'react';

interface InlineNoteInputProps {
  value: string;
  onChange: (value: string) => void;
  onClose: () => void;
}

export function InlineNoteInput({ value, onChange, onClose }: InlineNoteInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleBlur = () => {
    if (!value.trim()) {
      onClose();
    }
  };

  return (
    <input
      ref={inputRef}
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={handleBlur}
      placeholder="Add note..."
      className="w-full mt-1 text-xs text-gray-600 bg-transparent border-none outline-none focus:text-gray-700 placeholder:text-gray-400"
    />
  );
}
